import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
 
import { observeResource } from "kea-resource";

type Entity = models.Sucursal;
import { columnas } from "./columns";
const resource = resources.Sucursal;
const observable = observeResource(resources.Sucursal.query);
export class SucursalList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar Sucursal?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/Sucursal/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/Sucursal/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Sucursales" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"SucursalListCookieKey"} items={observable} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/list/list.tsx